"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnspecifiedPrompt = exports.GetAbstractPromptResponse = void 0;
var class_transformer_1 = require("class-transformer");
var class_validator_1 = require("class-validator");
var abstract_struct_1 = require("../abstract-struct");
var prompt_conditions_1 = require("./prompt-conditions");
var prompt_style_1 = require("../../enums/prompts/prompt-style");
var case_insensitive_ingest_1 = require("../../class-transformers/case-insensitive-ingest");
var is_not_empty_string_1 = require("../../class-validators/is-not-empty-string");
var native_prompt_config_1 = require("./styles/native/native-prompt-config");
var custom_prompt_config_1 = require("./styles/custom/custom-prompt-config");
var bell_prompt_config_1 = require("./styles/bell/bell-prompt-config");
var slide_prompt_config_1 = require("./styles/slide/slide-prompt-config");
var is_not_xss_vulnerability_1 = require("../../class-validators/is-not-xss-vulnerability");
var GetAbstractPromptResponse = (function (_super) {
    __extends(GetAbstractPromptResponse, _super);
    function GetAbstractPromptResponse() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsPositive)(),
        __metadata("design:type", Number)
    ], GetAbstractPromptResponse.prototype, "id", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'domain_id', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        __metadata("design:type", Number)
    ], GetAbstractPromptResponse.prototype, "domainId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'prompt_group_id', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsPositive)(),
        __metadata("design:type", Number)
    ], GetAbstractPromptResponse.prototype, "promptGroupId", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, is_not_xss_vulnerability_1.IsNotXssVulnerability)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "name", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'computed_name', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, is_not_empty_string_1.IsNotEmptyString)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "computedName", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsIn)([prompt_style_1.PromptStyle.BELL, prompt_style_1.PromptStyle.NATIVE, prompt_style_1.PromptStyle.PUBLISHER_CUSTOM, prompt_style_1.PromptStyle.SLIDE]),
        __metadata("design:type", String)
    ], GetAbstractPromptResponse.prototype, "style", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'is_auto_show' }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsBoolean)(),
        __metadata("design:type", Boolean)
    ], GetAbstractPromptResponse.prototype, "isAutoShow", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], GetAbstractPromptResponse.prototype, "weight", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function () { return prompt_conditions_1.PromptConditions; }),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "conditions", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.ValidateNested)(),
        (0, class_transformer_1.Type)(function (options) {
            var _a;
            switch ((_a = options === null || options === void 0 ? void 0 : options.object) === null || _a === void 0 ? void 0 : _a.style) {
                case prompt_style_1.PromptStyle.SLIDE:
                    return slide_prompt_config_1.SlidePromptConfig;
                case prompt_style_1.PromptStyle.PUBLISHER_CUSTOM:
                    return custom_prompt_config_1.CustomPromptConfig;
                case prompt_style_1.PromptStyle.BELL:
                    return bell_prompt_config_1.BellPromptConfig;
                case prompt_style_1.PromptStyle.NATIVE:
                    return native_prompt_config_1.NativePromptConfig;
                default:
                    return function () { return null; };
            }
        }),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "config", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_at', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsISO8601)(),
        __metadata("design:type", String)
    ], GetAbstractPromptResponse.prototype, "createdAt", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'created_by', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.Min)(0),
        (0, class_validator_1.IsInt)(),
        __metadata("design:type", Number)
    ], GetAbstractPromptResponse.prototype, "createdBy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'updated_at', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsISO8601)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "updatedAt", void 0);
    __decorate([
        (0, class_transformer_1.Expose)({ name: 'updated_by', toClassOnly: true }),
        (0, case_insensitive_ingest_1.CaseInsensitiveIngest)(),
        (0, class_validator_1.IsInt)(),
        (0, class_validator_1.IsOptional)(),
        __metadata("design:type", Object)
    ], GetAbstractPromptResponse.prototype, "updatedBy", void 0);
    return GetAbstractPromptResponse;
}(abstract_struct_1.AbstractStruct));
exports.GetAbstractPromptResponse = GetAbstractPromptResponse;
var UnspecifiedPrompt = (function (_super) {
    __extends(UnspecifiedPrompt, _super);
    function UnspecifiedPrompt() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        (0, class_validator_1.IsNotIn)([prompt_style_1.PromptStyle.UNKNOWN]),
        __metadata("design:type", String)
    ], UnspecifiedPrompt.prototype, "style", void 0);
    return UnspecifiedPrompt;
}(abstract_struct_1.AbstractStruct));
exports.UnspecifiedPrompt = UnspecifiedPrompt;
//# sourceMappingURL=get-abstract-prompt-response.js.map